/* eslint-disable
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from 'underscore';

import * as popup from 'Popup';
import * as net from 'util/Net';

function checkPrimer(primerID, bases, saveCallback, filterId, failCallback) {
  net
    .getJSON(`/1/api/sequences/${primerID}/check`, {bases})
    .done((res) => {
      // eslint-disable-next-line no-restricted-syntax
      let filtered = _.filter(res, (seq) => filterId !== seq.id);
      if (filtered.length !== 0) {
        let msg, names;
        // eslint-disable-next-line no-restricted-syntax
        filtered = _.map(filtered, (seq) => `<b>${_.escape(seq.name)}</b>`);
        if (filtered.length > 2) {
          filtered[filtered.length - 2] = `${filtered[filtered.length - 2]}, and ${
            filtered[filtered.length - 1]
          }`;
          filtered.length -= 1;
          names = filtered.join(', ');
        } else {
          names = filtered.join(' and ');
        }
        // names is already properly escaped HTML and can be safely interpolated.
        if (filterId != null) {
          msg = `This primer is also attached to ${names}. Editing its bases may affect other binding sites.`;
        } else {
          msg = `This primer is attached to ${names}. Editing its bases may affect binding sites.`;
        }
        new popup.Confirm({
          title: 'Primer Edits',
          msg,
        })
          .choice('Save', 'btn-af-success', saveCallback)
          .choice('Cancel', 'btn-af-default')
          .show();
      } else {
        saveCallback();
      }
    })
    .fail(failCallback);
}

export {checkPrimer};
